import { Skeleton } from "@pg/design-system";

export function SkeletonCard() {
    return (
        <Skeleton className="w-full rounded-[8px]" />
    )
}